// The unit after a THC/CBD number. The portal returns each product's and
// lot's unit (`test_units`: "%", "mg", "mg/ml", "mg/cap", "mg/unit"); flower,
// pre-rolls and vapes are stored in % (waio-portal project/products/potency.py),
// edibles, oils and capsules keep their own mg unit, so "10 mg", not "10%".
export function potencySuffix(unit?: string | null): string {
  const u = (unit ?? '').trim()
  return !u || u === '%' ? '%' : ` ${u}`
}
